import { ROUTES } from "~/constants/routing";

// The embed page is framed into other people's sites: their readers never
// agreed to our analytics or session recording, so neither may load there.
export const shouldLoadAnalytics = (pathname: string): boolean =>
  pathname !== ROUTES.embed.path &&
  !pathname.startsWith(`${ROUTES.embed.path}/`);
